export default [
  { to: 'allmant', title: 'Allmänt' },
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'arkiv', title: 'Arkiv' },
  { to: 'changelog', title: 'Ändringslogg' },
];
